module.exports = __webpack_public_path__ + "static/media/rg-front.5d6fc3ff.jpg";